var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import LoggerProvider from './Provider';
var withLogger = function (_a) {
    var namespace = _a.namespace;
    var enhancer = function (Component) { return function (props) { return (_jsx(LoggerProvider, __assign({ namespace: namespace }, { children: _jsx(Component, __assign({}, props), void 0) }), void 0)); }; };
    return enhancer;
};
export default withLogger;
//# sourceMappingURL=withLogger.js.map